import  {eXcell,__extends} from './eXcell';

var eXcell_img = (function (_super) {
    __extends(eXcell_img, _super);
    function eXcell_img(a) {
        _super.call(this);
        try {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
        }
        catch (c) {
            console.log(c);
        }
    }
    eXcell_img.prototype.getValue = function () {
        if (this.cell.firstChild.tagName == "IMG") {
            return (this.cell.firstChild.src +
                (this.cell.titFl != null ? "^" + this.cell._brval : ""));
        }
        else {
            if (this.cell.firstChild.tagName == "A") {
                var e = this.cell.firstChild.firstChild.src +
                    (this.cell.titFl != null ? "^" + this.cell._brval : "");
                e += "^" + this.cell.lnk;
                if (this.cell.trg) {
                    e += "^" + this.cell.trg;
                }
                return e;
            }
        }
    };
    eXcell_img.prototype.isDisabled = function () {
        return true;
    };
    eXcell_img.prototype.getTitle = function () {
        return this.cell._brval;
    };
    eXcell_img.prototype.setValue = function (e) {
        var c = e;
        if ((e || "").indexOf("^") != -1) {
            var a = e.split("^");
            e = a[0];
            c = this.cell._attrs.title || a[1];
            if (a.length > 2) {
                this.cell.lnk = a[2];
                if (a[3]) {
                    this.cell.trg = a[3];
                }
            }
            this.cell.titFl = "1";
        }
        if (!this.grid.multiLine) {
            this.setCValue("<img src='" +
                this.grid.iconURL +
                (e || "")._dhx_trim() +
                "' border='0' style='max-height:" +
                (this.grid._srdh - 4) +
                "px'>", e);
        }
        else {
            this.setCValue("<img src='" +
                this.grid.iconURL +
                (e || "")._dhx_trim() +
                "' border='0'>", e);
        }
        if (this.cell.lnk) {
            this.cell.innerHTML =
                "<a href='" +
                    this.cell.lnk +
                    "' target='" +
                    this.cell.trg +
                    "'>" +
                    this.cell.innerHTML +
                    "</a>";
        }
        this.cell._brval = c;
    };
    return eXcell_img;
})(eXcell);
window.eXcell_img = eXcell_img;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_img.js